<template>
  <div class="register-page">
    <!-- 左侧背景图 -->
    <div class="register-left"></div>

    <!-- 右侧注册框 -->
    <div class="register-right">
      <el-card class="register-card">
        <h2 class="register-title">注册</h2>
        <el-form :model="registerForm"
                 :rules="rules"
                 ref="registerForm"
                 label-width="80px">
          <!-- 账号输入框 -->
          <el-form-item label="账号"
                        prop="account">
            <el-input v-model="registerForm.account"
                      placeholder="请输入账号（推荐使用邮箱）"></el-input>
          </el-form-item>
          <el-form-item label="用户名"
                        prop="username">
            <el-input v-model="registerForm.username"
                      placeholder="请输入用户名"></el-input>
          </el-form-item>

          <!-- 密码输入框 -->
          <el-form-item label="密码"
                        prop="password">
            <el-input v-model="registerForm.password"
                      type="password"
                      placeholder="请输入密码"></el-input>
          </el-form-item>

          <!-- 确认密码输入框 -->
          <el-form-item label="确认密码"
                        prop="confirmPassword">
            <el-input v-model="registerForm.confirmPassword"
                      type="password"
                      placeholder="请再次输入密码"></el-input>
          </el-form-item>

          <!-- 手机号输入框 -->
          <el-form-item label="手机号"
                        prop="phone">
            <el-input v-model="registerForm.phone"
                      placeholder="请输入手机号"></el-input>
          </el-form-item>

          <!-- 邮箱输入框 -->
          <el-form-item label="邮箱"
                        prop="email">
            <el-input v-model="registerForm.email"
                      placeholder="请输入邮箱"></el-input>
          </el-form-item>

          <!-- 教师ID -->
          <el-form-item label="教师ID"
                        prop="teacherAccount">
            <el-input v-model="registerForm.teacherAccount"
                      placeholder="请输入教师ID"></el-input>
          </el-form-item>

          <!-- 注册按钮 -->
          <el-form-item class="register-button-center">
            <el-button type="primary"
                       @click="onSubmit">注册</el-button>
          </el-form-item>
          <div class="login-footer">
            <el-link @click="onBack">返回登录</el-link>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'; // 导入 axios

export default {
  data() {
    return {
      registerForm: {
        account: '',
        username: '',
        password: '',
        confirmPassword: '',
        phone: '',
        email: '',
        teacherAccount: '' // 修改为 teacherAccount
      },
      rules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 3, max: 25, message: '账号长度应在3到25个字符之间', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9@.\-\\_\\+]+$/, message: '账号只能包含字母、数字和特殊字符（@、.、-、_、+）', trigger: 'blur' } // 更新验证规则
        ]
        ,
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 25, message: '用户名长度应在2到5个字符之间', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]+$/, message: '用户名只能包含英文字符、数字', trigger: 'blur' } // 允许中文
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.registerForm.password) {
                callback(new Error('两次密码输入不一致'));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    async onSubmit() {
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          try {
            // 发送注册请求
            const response = await axios.post('/api/auth/addUser', {
              userName: this.registerForm.username,
              password: this.registerForm.password,
              phone: this.registerForm.phone,
              email: this.registerForm.email,
              accountNumber: this.registerForm.account,
              teacherId: this.registerForm.teacherAccount
            });

            // 注册成功的处理
            if (response.data.success) {
              this.$message.success('注册成功');
              setTimeout(() => {
                this.$router.push('/login'); // 注册成功后跳转到登录页面
              }, 2000);
            } else {
              // 如果后端返回了错误信息，提示用户
              this.$message.error(response.data.msg || '注册失败，请重试');
            }
          } catch (error) {
            // 处理请求错误
            console.error(error);
            this.$message.error('注册失败，请检查网络或稍后重试');
          }
        } else {
          console.log('注册表单验证失败');
        }
      });
    },
    onBack() {
      this.$router.push('/login'); // 返回登录页面
    }
  }
};
</script>

<style scoped>
.register-page {
  display: flex;
  height: 100vh;
  background-image: url("/image/login.jpg"); /* 背景图片 */
  background-size: cover;
  background-position: center;
}

.register-left {
  flex: 1;
  background-size: cover;
  background-position: center;
}

.register-right {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.register-card {
  width: 100%;
  max-width: 400px;
}

.register-title {
  text-align: center;
  margin-bottom: 20px;
}

.register-button-center {
  text-align: center;
  width: 100%;
}
.register-button-center button {
  width: 50%;
  margin-left: -70px;
}

.register-footer {
  display: flex;
  justify-content: space-between;
}

.login-footer {
  display: flex;
  justify-content: space-between;
}
</style>
